import { render, staticRenderFns } from "./GuanLianPz.vue?vue&type=template&id=b29a9028&scoped=true&"
import script from "./GuanLianPz.vue?vue&type=script&lang=js&"
export * from "./GuanLianPz.vue?vue&type=script&lang=js&"
import style0 from "./GuanLianPz.vue?vue&type=style&index=0&id=b29a9028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29a9028",
  null
  
)

export default component.exports